module.exports = __webpack_public_path__ + "img/item-6.0651399b.png";